import { useLocation } from '@reach/router';
import React from 'react';
import BurgerBtn from './BurgerBtn';
import HeaderLogo from './HeaderLogo';
import { PromoCountdown } from './PromoCountdown';
import SpecialsBanner from './SpecialsBanner';

function HeaderTop({ isOpen, setIsOpen, showCountdown }) {
    const location = useLocation();
    const hideConsultBtn = location.pathname === '/homepage-v2';

    return (
        <section id="header-top">
            <div className="container">
                <nav className="row justify-content-center align-items-center">
                    {/* WEBDEV-4313: full width at every breakpoint — no col-xxl-10. Bootstrap's xxl
                        fires at 1400px but the Tailwind .container is capped at 1280px, so that step
                        adds no width for a tenth to come out of: it only shifted the logo and CTA
                        106px inward from one pixel of resize. Same on HeaderBottom and SearchContainer,
                        so all three header rows track the container together. */}
                    <div className="col-xl-12">
                        <div className="row justify-content-between align-items-center">
                            <div className="col">
                                <HeaderLogo setIsOpen={setIsOpen} />
                            </div>
                            <div className="col-auto">
                                <div className="row align-items-center">
                                    <div className="col-auto d-none d-lg-block overflow-hidden">
                                        {!showCountdown && <SpecialsBanner />}
                                    </div>
                                    <div
                                        id="consult-col"
                                        className={`col-auto ${hideConsultBtn && 'hide-consult-btn'}`}
                                    >
                                        <a href="#consult" className="milan-btn consult-btn">
                                            FREE CONSULT
                                        </a>
                                    </div>
                                    <div className="col-auto d-inline-block d-lg-none">
                                        <BurgerBtn handleClick={() => setIsOpen(!isOpen)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
            {showCountdown && (
                <div className="d-none d-lg-block">
                    <PromoCountdown />
                </div>
            )}
        </section>
    );
}

export default HeaderTop;
